import styled, { css } from 'styled-components/macro';
import {
  ButtonFilter,
  transactionFilter,
  TransactionFilterDiv
} from '../TableFilterStyles';
import Icon from '../Icon';

export const CsvP = styled.p`
  color: ${props => props.theme.brand};
`;

export const CsvFilterDiv = styled.div`
  ${props =>
    props.filterRow &&
    css`
      ${transactionFilter};
      ${ButtonFilter};
    `}
  ${props =>
    !props.filterRow &&
    css`
      display: flex;
      align-items: center;
    `}
    cursor: pointer;

  ${props =>
    props.disabled
      ? css`
          cursor: not-allowed;
        `
      : css`
          &:hover {
            ${CsvP} {
              color: ${props => props.theme.indigo};
              text-decoration: underline;
            }
            svg {
              fill: ${props => props.theme.indigo};
            }
          }
        `}
`;

export const DownloadIcon = styled(Icon)`
  fill: ${props => props.theme.brand};
  width: 2rem;
  height: 1.5rem;
`;
export const CustomCsvImg = styled.img`
  width: 16px;
  margin-right: 5px;
  cursor: pointer;
`;

export const CustomCsvP = styled.p`
  cursor: pointer;
  && {
    font-weight: 500;
    color: ${props => props.theme[props.color]};
  }
  text-transform: initial;
`;

export const CustomTransactionFilterDiv = styled(TransactionFilterDiv)`
  justify-content: flex-end;
  @media screen and (max-width: 767px) {
    padding-right: 0;
  }
  ${props =>
    props.center &&
    css`
      justify-content: center;
    `}
  ${props =>
    props.disabled &&
    css`
      > p {
        cursor: not-allowed;
      }
    `}
    svg {
    margin-right: 5px;
  }
`;
